import * as React from 'react';
import { observer } from 'mobx-react';
import { classes, style } from 'typestyle';
import { important, px } from 'csx';
import { fontHeading } from '../theme/font';
import {colorContrast, colorSlate, colorWhite} from '../theme/color';
import { transitionQuickEase } from '../theme/transition';
import { centerCenter } from 'csstips';
import { Tooltip } from './tooltip';
import { zLabel } from '../theme/z';

export interface BrandSponsoredLabelProps {
  className?: string;
  expanded?: boolean;
  invert?: boolean;
  i18n?: {
    short: string;
    long: string;
    title: string;
  }
}

@observer
export class BrandSponsoredLabel extends React.Component<BrandSponsoredLabelProps, any> {
  render() {
    const { i18n = BrandSponsoredLabel.i18n, className, expanded, invert } = this.props;

    return (
      <Tooltip dockRight={true} content={i18n.title} className={classes(
        BrandSponsoredLabel.styles.brandSponsored,
        className
      )}>
        <span className={classes(BrandSponsoredLabel.styles.text, invert && BrandSponsoredLabel.styles.invert)}>
          {expanded ? i18n.long : i18n.short}
        </span>
      </Tooltip>
    )
  }

  static i18n = {
    short: 'B',
    long: 'Brand Sponsored',
    title: 'This track can be used in Brand Sponsored videos'
  };

  static styles = {
    brandSponsored: style(
      {
        ...centerCenter,
        display: 'inline-flex',
        position: 'relative',
      }
    ),
    text: style({
      zIndex: zLabel,
      position: 'relative',
      cursor: 'default',
      userSelect: 'none',
      textTransform: 'uppercase',
      textDecoration: important('none'),
      fontFamily: fontHeading,
      display: 'inline-block',
      color: colorContrast.toString(),
      border: '1px solid',
      borderColor: colorContrast.toString(),
      background: colorWhite.toString(),
      borderRadius: '2px',
      padding: '2px 4px 1px',
      fontSize: '13px',
      fontWeight: 700,
      lineHeight: '16px',
      opacity: 1,
      transition: `all ${transitionQuickEase}`
    }),
    invert: style({
      background: important(colorSlate.toString())
    })
  };
}